import "./Intro.css";
import logo from "../../../assets/images/DarkLogo.webp";
import DownloadButtons from "../../../components/DownloadButton/DownloadButtons";
import phone1 from "../../../assets/images/Phone1.png";
import downButton from "../../../assets/images/DownButton.png";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Intro = () => {
  const navigate = useNavigate();

  const handlewebLink = () => {
    navigate("/lajmet");
  };

  const handleScrollDown = () => {
    const section = document.getElementById("about-us");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="intro-section">
      <div className="intro-left-section">
        <div id="logo-section">
          <img src={logo} alt="logo" />
        </div>
        <h1 id="intro-title">
          Lidhuni{" "}
          <span className="yellowText">
            me <br />
          </span>{" "}
          <span className="yellowText">Botën</span> Përreth Jush{" "}
        </h1>

        <div className="intro-p">
          <p>Qëndroni të informuar me titujt më të fundit në një vend.</p>
          <p>
            <b>
              Shkarkoni <span className="yellowText">Aplikacionin</span>
            </b>
          </p>
        </div>

        <DownloadButtons />
        <h3 id="web-link" onClick={handlewebLink}>
          Vizitoni web aplikacionin →
        </h3>

        <div className="scroll-down" onClick={handleScrollDown}>
          <img src={downButton} alt="scroll down" />
          <h3>Vijoni poshtë</h3>
        </div>
      </div>
      <div className="intro-right-section">
        <img src={phone1} alt="phoneImage" />
      </div>
    </section>
  );
};

export default Intro;
